import type { FieldDescriptor } from './FieldDescriptor';

export default class BaseModel<I> {
  public declare response: I;

  constructor(data: I) {
    this.response = data;
    if (!this.response) {
      return;
    }
    this.transformResponse();
  }

  public get metadata(): Record<string, any> {
    return {};
  }

  protected transformResponse(): void {
    // transform response to model
  }

  protected updateResponse(data: I): void {
    this.response = data;
    this.transformResponse();
  }

  public toList(): IDataList {
    const fields = this.getFields();
    if (!fields) return {};

    return this.buildList(fields);
  }

  public toProvidedInfo(): IDataList {
    return {};
  }

  public toResponse(): I {
    return { ...this.response };
  }

  // Override in child classes to provide field descriptors for list generation
  protected getFields(): Record<string, FieldDescriptor> | null {
    return null;
  }

  protected buildList(fields: Record<string, FieldDescriptor>): IDataList {
    const result: IDataList = {};
    Object.entries(fields).forEach(([label, descriptor]) => {
      if (!descriptor.shouldShow(this)) return;
      result[label] = descriptor.resolve(this);
    });
    return result;
  }
}
